import { useQuery } from "react-query";
import {
	get_all_cuisine_api,
	add_cuisine,
	update_cuisine,
	delete_cuisine_by_id_api,
} from "../services/cuisine";
import { useMutation } from "react-query";

export const useGetAllCuisine = (params) =>
	useQuery(["getAllCuisine", params], () => get_all_cuisine_api(params));

export const useAddFoodsCuisine = () =>
	useMutation("addFoodCuisine", (body) => add_cuisine(body));

export const useUpdateFoodCuisine = () =>
	useMutation("updateFoodCuisine", (body) => update_cuisine(body));

export const useDeleteCuisineById = () =>
	useMutation("deleteCuisine", (body) => delete_cuisine_by_id_api(body));
